var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 71.1",
    style: {
      enableBackground: "new 0 0 71.6 71.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5C2881;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35.8,
    cy: 35.5,
    r: 35.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18,28 18,45.6 28.6,36.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.8,22.5h-30c-1.4,0-2.5,1-2.8,2.3l14,11.6l2.3,1.9c0.8,0.7,2.1,0.7,2.9,0l2.5-2l13.9-11.5 C53.4,23.5,52.2,22.5,50.8,22.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.6,45.6 53.6,28 43.1,36.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.2,40.1l-1.9,1.6c-0.8,0.7-2.1,0.7-2.9,0l-2.4-2l-1.4-1.2l-11.4,9.5c0.5,0.4,1.1,0.6,1.8,0.6h30 c0.7,0,1.3-0.2,1.8-0.6l-11.4-9.5L39.2,40.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.4dc56aad1cf3d017f0d09d482923e8b6.svg";
export { ForwardRef as ReactComponent };